import { Construction } from 'lucide-react';
import { PageHeader } from '@/ui/page-header';
import { EmptyState } from '@/ui/empty-state';

/**
 * The destination for every route that exists in navigation but has no mockup yet
 * (docs/FRONTEND_REBUILD.md section 6).
 *
 * These routes are deliberately visible and clickable rather than hidden or disabled:
 * navigation must look complete. What they must not do is pretend to have content.
 */
export function Stub({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <div className="grid gap-8">
      <PageHeader title={title} subtitle={subtitle ?? 'Not yet designed'} />
      <EmptyState
        title={`${title} has no design yet.`}
        note="Screen intentionally left empty"
        icon={<Construction className="size-6" />}
      />
    </div>
  );
}
